import script from "./DescriptionInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DescriptionInput.vue?vue&type=script&setup=true&lang=js"

import "./DescriptionInput.vue?vue&type=style&index=0&id=63769cf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63769cf0"]])

export default __exports__